import type { AppModule } from '@shared/presentation/router/composition.js';
import { loginModule } from './login/module.js';
import { usersModule } from './users/module.js';

/**
 * `identity` context: who signs in and who is allowed to.
 *
 * Adding a feature to this context is one line here.
 */
export const identityModules: AppModule[] = [loginModule, usersModule];
